module.exports = __webpack_public_path__ + "assets/img/13@3x.3db3337a.png";